import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Loader2 } from 'lucide-react';
import PostCard from '@/components/PostCard';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function PostDetail() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const [postRes, meRes] = await Promise.all([
          axios.get(`${BACKEND_URL}/api/posts/${id}`, { withCredentials: true }),
          axios.get(`${BACKEND_URL}/api/auth/me`, { withCredentials: true }).catch(() => ({ data: null })),
        ]);
        setPost(postRes.data);
        setCurrentUser(meRes.data || null);
      } catch {
        setPost(null);
      } finally {
        setLoading(false);
      }
    };
    if (id) load();
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen pt-28 flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!post) {
    return (
      <div className="min-h-screen pt-24 px-4 max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-white">
          <ArrowLeft className="w-4 h-4" /> Back to feed
        </Link>
        <div className="mt-8 text-center border border-dashed border-white/10 rounded-2xl py-16">
          <p className="text-muted-foreground">Post not found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-24 pb-16 px-4">
      <div className="max-w-2xl mx-auto space-y-5">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-white">
          <ArrowLeft className="w-4 h-4" /> Back to feed
        </Link>
        <PostCard post={post} currentUser={currentUser} onDelete={() => {}} />
      </div>
    </div>
  );
}
